import React, {useEffect, useRef, useState, useMemo} from 'react';
import qs from 'qs';
import {ControlLabel} from 'react-bootstrap';

const RegistrationPreview = (
    {
        event,
        settings,
        params,
        isFormVisible,
        isPreviewUpdated,
    }
) => {
    const ref = useRef();
    const [iframeHeight, setIframeHeight] = useState('400px');

    useEffect(() => {
        const messageHandler = (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

                if (!data) {
                    return;
                }

                if (data.hasOwnProperty('setHeight')) {
                    setIframeHeight(data.setHeight + 'px');
                }
            } catch (error) {
                console.error(error);
            }
        };

        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);

    useEffect(() => {
        ref.current.contentWindow.postMessage({
            changeWidgetSettings: settings,
            isFormVisible,
            isPreviewUpdated,
        }, '*');
    }, [isFormVisible, isPreviewUpdated, settings]);

    function onWidgetLoad() {
        setTimeout(() => {
            setIframeHeight(`${ref.current.contentWindow.document.body.scrollHeight}px`);
        }, 1000);
    };

    const query = useMemo(() => qs.stringify(params, { skipNulls: true, encode: false }), [params]);

    return (
        <div style={{position: 'sticky', top: '60px', left: 0}}>
            <ControlLabel>
                Виджет регистрации
            </ControlLabel>
            <p>
                <span className={`widget-registration__breadcrumb-item large ${isFormVisible ? 'active' : ''}`}>
                    Первый экран (Поля регистрации) /
                </span>
                <span className={`widget-registration__breadcrumb-item large ${!isFormVisible ? 'active' : ''}`}>
                    Второй экран "{event.moduleAuth.accessPreModeration ? 'Заявка принята' : 'Регистрация пройдена успешно'}"
                </span>
            </p>
            <iframe
                ref={ref}
                src={`/widget-registration/${event.eventKey}/registration?${query}`}
                width="100%"
                height={iframeHeight}
                frameBorder="0"
                scrolling="no"
                allowFullScreen={true}
                onLoad={onWidgetLoad}
            />
        </div>
    )
};

export default RegistrationPreview;
